import { render } from "./DebugToggle.vue?vue&type=template&id=12747ab8"
import script from "./DebugToggle.vue?vue&type=script&lang=js"
export * from "./DebugToggle.vue?vue&type=script&lang=js"

import "./DebugToggle.vue?vue&type=style&index=0&id=12747ab8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__